export default __webpack_public_path__ + "static/media/fire-protection.a8456180.png";